export default "__VITE_ASSET__BhlPkKlB__"